import { Box } from "@chakra-ui/core"
import React from "reactn"
export const HtmlBox = ({ children, ...props }) => (
  <Box dangerouslySetInnerHTML={{ __html: children }} {...props} />
)
